import React from 'react';
import KeyboardFormField from '@common/components/keyboardFormField';
import PropTypes from 'prop-types';
import { PasswordStrengthMeter } from '@app/dev/terminal/components/passwordChecker';
import { credetialFields } from '../constants/credentialFields';

export const Credential = ({
  form, setForm, errors,
}) => {
  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  return (
    <div className="popup-register-wide-form">
      <div className="input-wrapper">
        {credetialFields.map((item) => {
          const FieldComponent = item.custumViewComponent || KeyboardFormField;
          return (
            <div key={item.name} className={`register-single-input ${item.className}`}>
              <FieldComponent
                readOnly={item.readOnly}
                key={item.name}
                type={item.type}
                name={item.fieldName}
                value={form[item.name]}
                onChange={(value) => onChange(item.name, value)}
                errorMessage={errors[item.name]}
              />
              {item.fieldName === 'Password' && <PasswordStrengthMeter password={form.password} />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

Credential.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  errors: PropTypes.object,
};
